import React, { useState, useContext, useEffect } from "react";
import avatar from "../../../assets/media/avatar.png";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { COUNTRY_STATE_N_CITY_LIST_URL } from "../../../utils/api-ends";
import { ManageCompleteUserProfileContext } from "./";
import useHttp from "../../../hooks/useHttp";

const BasicInfo = () => {
  const [userInfoState, userInfoContextDispatch] = useContext(
    ManageCompleteUserProfileContext
  );
  const [crop, setCrop] = useState({
    unit: "%",
    width: 90,
    height: 66.667,
    x: 25,
    y: 25,
  });

  const imgRef = React.useRef(null);
  const canvas_ref = React.useRef(undefined);
  const [open, setOpen] = React.useState(false);
  const { sendRequests } = useHttp();
  const userInfo = userInfoState.userInfo;

  const crop_size = () => {
    if (imgRef.current) {
      let { width, height } = imgRef.current;
      let crop_option = centerCrop(
        makeAspectCrop(
          {
            unit: "%",
            width: 90,
          },
          27 / 20,
          width,
          height
        ),
        width,
        height
      );
      setCrop(crop_option);

      userInfoContextDispatch({
        type: "ON_CHANGE_USER_INFO",
        payload: {
          profile_image_screen_width: width,
          profile_image_screen_height: height,
        },
      });
    }
  };

  const imageCropModalOpen = () => setOpen(true);
  const imageCropModalClose = () => {
    setOpen(false);
    crop_size();
  };

  const handleInputChange = (e) => {
    let payload = { [e.target.name]: e.target.value };

    if (e.target.name === "profile_picture") {
      payload["profile_picture"] = URL.createObjectURL(e.target.files[0]);
      payload["profile_picture_file"] = e.target.files[0];
    }

    userInfoContextDispatch({
      type: "ON_CHANGE_USER_INFO",
      payload: payload,
    });

    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.name]: [] },
    });
  };

  // Clean error messages when click on the input
  const hideErrorMessage = (e) => {
    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.getAttribute("name")]: [] },
    });
  };

  useEffect(() => {
    crop_size();
  }, [imgRef.current]);

  // Fetch list of country
  useEffect(() => {
    const response = (data) => {
      userInfoContextDispatch({
        type: "COUNTRY_LIST",
        payload: data,
      });
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  }, []);

  // // Fetch list of state
  useEffect(() => {
    const response = (data) => {
      userInfoContextDispatch({
        type: "STATE_LIST",
        payload: data,
      });
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "states",
          country_name: userInfo.user_obj.country,
        },
      },
      response
    );
  }, [userInfo.user_obj.country]);

  // Fetch list of city
  useEffect(() => {
    const response = (data) => {
      userInfoContextDispatch({
        type: "CITY_LIST",
        payload: data,
      });
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "cities",
          country_name: userInfo.user_obj.country,
          state_name: userInfo.user_obj.state,
        },
      },
      response
    );
  }, [userInfo.user_obj.country, userInfo.user_obj.state]);

  const get_image_blob_data = (e) => {
    try {
      let reader = new FileReader();
      reader.onload = function (el) {
        userInfoContextDispatch({
          type: "ON_CHANGE_USER_INFO",
          payload: {
            profile_picture_default_url: el.target.result,
          },
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    } catch {}
  };

  const imageCropComplete = (crop) => {
    userInfoContextDispatch({
      type: "ON_CHANGE_USER_INFO",
      payload: {
        profile_image_x: crop.x,
        profile_image_y: crop.y,
        profile_image_width: crop.width,
        profile_image_height: crop.height,
      },
    });

    let image = imgRef.current;
    if (!canvas_ref.current) return;
    const imageCanvas = canvas_ref.current;

    let scale = 1;
    let rotate = 0;
    const TO_RADIANS = Math.PI / 180;
    const ctx = imageCanvas.getContext("2d");

    if (!ctx) return;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1

    imageCanvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    imageCanvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    ctx.translate(-cropX, -cropY);

    ctx.translate(centerX, centerY);

    ctx.rotate(rotateRads);

    ctx.scale(scale, scale);

    ctx.translate(-centerX, -centerY);

    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );

    ctx.restore();

    try {
      imageCanvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);

        userInfoContextDispatch({
          type: "ON_CHANGE_USER_INFO",
          payload: {
            profile_picture: url,
          },
        });
      });
    } catch (error) {}
  };

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label>First name :</label>
          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            value={userInfo.user_obj.first_name}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.first_name.length > 0 ? (
              <div>
                <i className="fa-solid fa-circle-exclamation"></i>
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.first_name?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Last name :</label>
          <input
            type="text"
            name="last_name"
            value={userInfo.user_obj.last_name}
            onChange={handleInputChange}
            placeholder="Last Name"
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.last_name.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.last_name?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Email :</label>
          <input
            type="text"
            name="email"
            placeholder="Email"
            value={userInfo.user_obj.email}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.email.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
             ""
            )}
            {userInfoState.userInfoError?.email?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Phone Number :</label>


          <div className="phone-number-input-area">
              <input
                type="text"
                defaultValue="+1"
                disabled="true"
                className="phone-number-input-code"
              />
              <input
                type="text"
                name="phone_number"
                placeholder="e.g. 6505552672"
                value={userInfo.user_obj.phone_number}
                onChange={handleInputChange}
                onMouseMove={hideErrorMessage}
              />
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.phone_number.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.phone_number?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Street Address :</label>
          <input
            type="text"
            placeholder="Street Address"
            name="street_address"
            value={userInfo.user_obj.street_address}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.street_address.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.street_address?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label> Country :</label>
          <div>
            <Select
              name="country"
              value={userInfo.user_obj.country}
              onChange={handleInputChange}
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
              onMouseMove={hideErrorMessage}
              inputProps={{ "aria-label": "Without label" }}>
              {userInfoState.countryList?.map((country, index) => (
                <MenuItem key={index} value={country}>
                  {country}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.state.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.state?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> State/Region :</label>
          <div>
            <Select
              name="state"
              value={userInfo.user_obj.state}
              onChange={handleInputChange}
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
              onMouseMove={hideErrorMessage}
              inputProps={{ "aria-label": "Without label" }}>
              {userInfoState.stateList?.map((state, index) => (
                <MenuItem value={state}>{state}</MenuItem>
              ))}
            </Select>
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.state.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.state?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> City :</label>
          <div>
            <Select
              name="city"
              value={userInfo.user_obj.city}
              onChange={handleInputChange}
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
              onMouseMove={hideErrorMessage}>
              {userInfoState?.cityList?.map((city, index) => (
                <MenuItem key={index} value={city}>
                  {city}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.city.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.city?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Zip Code :</label>
          <input
            type="text"
            placeholder="Zip Code"
            name="zip_code"
            value={userInfo.user_obj.zip_code}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.zip_code.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.zip_code?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Profile Picture :</label>
          <input
            type="file"
            name="profile_picture"
            onChange={(e) => {
              handleInputChange(e);
              get_image_blob_data(e);
              imageCropModalOpen();
            }}
            onMouseMove={hideErrorMessage}
          />
          <div className="file-info">
            <i className="fas fa-image"></i>
            <span>Choose your image </span>
          </div>
          <div className="error" show-tittle="true">
            {/* {userInfoState.userInfoError?.profile_picture.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              <a></a>
            )}
            {userInfoState.userInfoError?.profile_picture?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )} */}
          </div>
        </div>

        <div
          className="user-image-update complete-user-profile-image"
          onClick={() => {
            userInfo.user_obj.profile_picture_default_url &&
              imageCropModalOpen();
          }}>
          <img
            src={
              userInfo.user_obj?.profile_picture
                ? userInfo.user_obj.profile_picture
                : avatar
            }
            alt="img"
          />
        </div>

        <canvas className="d-none" ref={canvas_ref}>
          {" "}
        </canvas>

        <Modal
          open={open}
          onClose={imageCropModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="user-sign-up-img-cropper-area">
          <div className="user-sign-up-img-modal">
            {userInfo.user_obj.profile_picture_default_url && (
              <ReactCrop
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={imageCropComplete}
                aspect={27 / 20}
                minWidth={60}
                keepSelection={true}>
                <img
                  ref={imgRef}
                  src={userInfo.user_obj.profile_picture_default_url}
                  alt="img"
                  style={{
                    maxWidth: `${window.innerWidth - 20}px`,
                    maxHeight: `${window.innerHeight - 300}px`,
                  }}
                />
              </ReactCrop>
            )}
            <Button
              className="theme-btn auth-image-resize-confirm-btn"
              onClick={imageCropModalClose}>
              Upload
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default BasicInfo;
